import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=4ec78f86&scoped=true"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=4ec78f86&lang=scss"
import style1 from "./LandingHeader.vue?vue&type=style&index=1&id=4ec78f86&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec78f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec78f86')) {
      api.createRecord('4ec78f86', component.options)
    } else {
      api.reload('4ec78f86', component.options)
    }
    module.hot.accept("./LandingHeader.vue?vue&type=template&id=4ec78f86&scoped=true", function () {
      api.rerender('4ec78f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/LandingHeader.vue"
export default component.exports